import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#262626",
  "fill-opacity": ".88",
  d: "M12.627 3.943c1.135-1.362 3.352-.559 3.352 1.214V20.84c0 1.772-2.217 2.575-3.352 1.213l-2.852-3.421a1.35 1.35 0 0 0-1.04-.488H5.417a2.98 2.98 0 0 1-2.98-2.979v-4.333a2.98 2.98 0 0 1 2.98-2.98h3.318c.402 0 .783-.178 1.04-.487zm1.727 1.214a.271.271 0 0 0-.479-.174l-2.852 3.422a2.98 2.98 0 0 1-2.288 1.073H5.417c-.748 0-1.354.606-1.354 1.354v4.333c0 .748.606 1.355 1.354 1.355h3.318c.884 0 1.723.392 2.288 1.07l2.852 3.423c.162.194.479.08.48-.173zm4.47.89a.813.813 0 0 1 1.127-.225c2.188 1.461 3.611 4.15 3.611 7.176s-1.423 5.715-3.61 7.176a.813.813 0 0 1-.903-1.352c1.698-1.134 2.889-3.294 2.889-5.824s-1.191-4.69-2.89-5.824a.813.813 0 0 1-.224-1.127m-1.083 4.333a.813.813 0 0 1 1.127-.225c.892.596 1.444 1.67 1.445 2.843 0 1.173-.553 2.246-1.445 2.842a.813.813 0 1 1-.902-1.352c.402-.269.721-.812.721-1.49s-.318-1.222-.721-1.491a.813.813 0 0 1-.225-1.127"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }